import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function downloadInvoice(requestData) {
  const apiPath = `/downloadInvoiceByteArray?invoiceID=${requestData.invoiceId}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.invoiceInstance().get(apiPath)
}
